import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./style.scss";

export default function MultiColumn({
  children,
  className = "",
  backgroundImage = null,
  type = "flex"
}) {
  const wrapperClasses = classNames("multi-column", type, className);

  return (
    <div
      className={wrapperClasses}
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : null
      }}
    >
      {children}
    </div>
  );
}

MultiColumn.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  backgroundImage: PropTypes.string,
  type: PropTypes.oneOf(["flex", "grid"])
};

MultiColumn.defaultProps = {
  className: "",
  backgroundImage: null,
  type: "flex"
};
